import { AiOutlineFolderOpen } from 'react-icons/ai'
import {
  BiArrowBack,
  BiCamera,
  BiCaretLeft,
  BiCaretRight,
  BiCheck,
  BiCheckCircle,
  BiChevronDown,
  BiChevronLeft,
  BiChevronRight,
  BiCrosshair,
  BiCube,
  BiDotsHorizontalRounded,
  BiDownload,
  BiErrorCircle,
  BiExport,
  BiGrid,
  BiHelpCircle,
  BiHide,
  BiImageAdd,
  BiListUl,
  BiMenu,
  BiMinus,
  BiPencil,
  BiPlus,
  BiReset,
  BiShow,
  BiTrash,
  BiX,
} from 'react-icons/bi'
import { BsArrowRightShort, BsCreditCard, BsFillCircleFill, BsPencil, BsScissors, BsTextareaT } from 'react-icons/bs'
import { CiRuler } from 'react-icons/ci'
import {
  FaChevronDown,
  FaChevronRight,
  FaChevronUp,
  FaExternalLinkAlt,
  FaRegCircle,
  FaRegObjectGroup,
  FaRegSave,
  FaRegSquare,
} from 'react-icons/fa'
import { FiEdit, FiPenTool } from 'react-icons/fi'
import { IoMdUndo } from 'react-icons/io'
import { LuArrowDownUp } from 'react-icons/lu'
import {
  MdCardMembership,
  MdClose,
  MdLockReset,
  MdOutlineAccountCircle,
  MdOutlineAutoAwesome,
  MdOutlineCancel,
  MdOutlineEdit,
  MdOutlineSummarize,
  MdOutlineVerticalAlignBottom,
  MdOutlineVerticalAlignTop,
  MdOutlineWarning,
} from 'react-icons/md'
import { PiCrosshair, PiCube, PiDiamond, PiFilePdfDuotone, PiGearSixBold, PiMicrosoftExcelLogo } from 'react-icons/pi'
import { RiAlertFill } from 'react-icons/ri'
import { RxDragHandleDots2 } from 'react-icons/rx'
import { TbChartGridDots, TbLayersLinked, TbZoomScan } from 'react-icons/tb'

import Comment from './icons/comment.svg?react'
import CubeBack from './icons/cube-back.svg?react'
import CubeDown from './icons/cube-down.svg?react'
import CubeFront from './icons/cube-front.svg?react'
import CubeLeft from './icons/cube-left.svg?react'
import CubeRight from './icons/cube-right.svg?react'
import CubeUp from './icons/cube-up.svg?react'
import Cuboid from './icons/cuboid.svg?react'
import LogoIconOnly from './icons/logo-icon.svg?react'
import LogoInverted from './icons/logo-inverted.svg?react'
import Logo from './icons/logo.svg?react'
import Move from './icons/move.svg?react'
import PCD from './icons/pcd.svg?react'
import ToolbarAxis1 from './icons/toolbar-axis-1.svg?react'
import ToolbarAxis2 from './icons/toolbar-axis-2.svg?react'
import ToolbarAxis3 from './icons/toolbar-axis-3.svg?react'
import ToolbarComment from './icons/toolbar-comment.svg?react'
import ToolbarCylinder from './icons/toolbar-cylinder.svg?react'
import ToolbarDepth from './icons/toolbar-depth.svg?react'
import ToolbarDistance from './icons/toolbar-distance.svg?react'
import ToolbarMove from './icons/toolbar-move.svg?react'
import ToolbarPlane from './icons/toolbar-plane.svg?react'
import ToolbarPolyline from './icons/toolbar-polyline.svg?react'
import ToolbarRotate from './icons/toolbar-rotate.svg?react'
import ToolbarScale from './icons/toolbar-scale.svg?react'
import ToolbarTranslate from './icons/toolbar-translate.svg?react'
import ToolbarVolumePolygon from './icons/toolbar-volume-estimation-polygon.svg?react'
import VertexAdd from './icons/vertex-add.svg?react'
import VertexConect from './icons/vertex-connect.svg?react'
import VertexMove from './icons/vertex-move.svg?react'
import VertexRemove from './icons/vertex-remove.svg?react'

export const ChevronRightIcon = BiChevronRight //* >矢印
export const ChevronDownIcon = BiChevronDown
export const CloseIcon = BiX //* 閉じる
export const WarningTwoIcon = MdOutlineWarning

export const ExternalLink = FaExternalLinkAlt

export const AddIcon = BiPlus
export const MinusIcon = BiMinus
export const AddImageIcon = BiImageAdd
export const AlertFillIcon = RiAlertFill
export const BackIcon = BiArrowBack
export const BigChevronDownIcon = FaChevronDown
export const BigChevronUpIcon = FaChevronUp
export const BigChevronRightIcon = FaChevronRight
export const CancelIcon = MdOutlineCancel
export const CaretLeftIcon = BiCaretLeft
export const CaretRightIcon = BiCaretRight
export const CircleFillIcon = BsFillCircleFill
export const ChevronLeftIcon = BiChevronLeft
export const ExpandIcon = BiChevronRight
export const ErrorIcon = BiErrorCircle
export const CollapseIcon = BiChevronDown
export const DeleteIcon = BiTrash
export const DiameterIcon = BiCrosshair
export const DownloadIcon = BiDownload
export const ExportIcon = BiExport
export const FolderIcon = AiOutlineFolderOpen
export const HDotsIcon = BiDotsHorizontalRounded
export const HideIcon = BiHide
export const RightArrowIcon = BsArrowRightShort

export const HelpCircleIcon = BiHelpCircle

export const InputEditorCancelIcon = BiX
export const InputEditorEditIcon = BiPencil
export const ListIcon = BiListUl
export const LogoDark = Logo
export const LogoLight = LogoInverted
export const LogoIcon = LogoIconOnly
export const MenuIcon = BiMenu
export const PencilIcon = BsPencil
export const BottomPlaneIcon = MdOutlineVerticalAlignBottom
export const TopPlaneIcon = MdOutlineVerticalAlignTop
export const ShowIcon = BiShow
export const ResetIcon = BiReset
export const UndoIcon = IoMdUndo
export const CubeUpIcon = CubeUp
export const CubeDownIcon = CubeDown
export const CubeLeftIcon = CubeLeft
export const CubeRightIcon = CubeRight
export const CubeFrontIcon = CubeFront
export const CubeBackIcon = CubeBack
export const PDFIcon = PiFilePdfDuotone
export const ExcelIcon = PiMicrosoftExcelLogo
export const CubeIcon = BiCube
export const EditorPageIcon = BiCube
export const GridIcon = BiGrid
export const CuboidIcon = Cuboid
export const PCDAlignmentIcon = TbLayersLinked
export const PCDIcon = PCD

export const FocusItemIcon = TbZoomScan

export const DeleteXIcon = MdClose

// ## Editor Toolbar Icons
export const ToolbarPolylineIcon = ToolbarPolyline
export const ToolbarCommentIcon = ToolbarComment
export const ToolbarCylinderIcon = ToolbarCylinder
export const ToolbarPlaneIcon = ToolbarPlane
export const ToolbarDistanceIcon = ToolbarDistance
export const ToolbarMoveIcon = ToolbarMove
export const ToolbarFocusButton = PiCrosshair
export const ToolbarCameraIcon = BiCamera
export const ToolbarVolumeIcon = ToolbarVolumePolygon
export const ToolbarVolumeIconPolygon = ToolbarVolumePolygon
export const ToolbarDepthIcon = ToolbarDepth
export const ToolbarMaskRegion = BsScissors
export const ToolbarGridIcon = TbChartGridDots

// Sub-toolbar icons
export const ToolbarScaleIcon = ToolbarScale
export const ToolbarTranslateIcon = ToolbarTranslate
export const ToolbarRotateIcon = ToolbarRotate
export const ToolbarAxis1Icon = ToolbarAxis1
export const ToolbarAxis2Icon = ToolbarAxis2
export const ToolbarAxis3Icon = ToolbarAxis3

export const SubtoolbarAddVertexIcon = VertexAdd
export const SubtoolbarMoveVertexIcon = VertexMove
export const SubtoolbarConnectVertexIcon = VertexConect
export const SubtoolbarRemoveVertexIcon = VertexRemove

// ## Blueprint Editor Icons
export const BlueprintEditorIcon = BiGrid
export const BlueprintEditorToolPenIcon = FiPenTool
export const BlueprintEditorToolCircleIcon = FaRegCircle
export const BlueprintEditorToolRectangleIcon = FaRegSquare
export const BlueprintEditorToolTextAnnotationIcon = BsTextareaT
export const BlueprintEditorToolMeasurementLabelIcon = CiRuler

export const ResetGridLockIcon = MdLockReset

export const CommentDisplayIcon = Comment
export const CommentMoveIcon = Move

export const SettingIcon = PiGearSixBold
export const EditBoxIcon = FiEdit
export const OrderIcon = LuArrowDownUp
export const OrderGrabIcon = RxDragHandleDots2

export const SuccessIcon = BiCheck
export const ConfirmIcon = BiCheck
export const CheckCircleIcon = BiCheckCircle
export const SaveIcon = FaRegSave
export const UnsavedIcon = MdOutlineEdit

export const CAD3DIcon = PiCube
export const CAD2DIcon = PiDiamond

export const Editor3DIcon = PiCube
export const Editor2DIcon = PiDiamond

// ## USER
export const MenuUserIcon = MdOutlineAccountCircle
export const MenuProjectSettingsIcon = MdOutlineSummarize
export const MenuPlanIcon = MdCardMembership

export const PaymentIcon = BsCreditCard

export const InspectionGroupIcon = FaRegObjectGroup

export const AutoAwesomeIcon = MdOutlineAutoAwesome
